import React from "react";
import styled from "styled-components";
import { Link } from "@inertiajs/react";
import { narrowScreenMediaQuery, dark, brand_orange_deep } from "../constants/styles";
import { unmodule } from "../util";

// Trimmed header for the auth pages — just the logo, a small brand tagline,
// and the cross-page link. No search, no multi-tier nav, no notification bell.
// Matches the rebranded homepage's sticky + backdrop-blur treatment so the
// auth pages feel like part of the site, not a detached SSO screen.
const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fef5e0eb;
  backdrop-filter: blur(6px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  [data-theme="dark"] & {
    background: rgba(23, 23, 30, 0.85);
    border-bottom-color: ${dark.border};
  }
`;

const Inner = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 14px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media ${narrowScreenMediaQuery} {
    padding: 12px 20px;
  }
`;

const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 12px;

  &:focus-visible {
    outline: 2px solid ${brand_orange_deep};
    outline-offset: 3px;
    border-radius: 4px;
  }
`;

const LogoImg = styled.img`
  height: 36px;
  width: auto;
  display: block;
`;

const Tagline = styled.span`
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  letter-spacing: 0.01em;

  @media ${narrowScreenMediaQuery} {
    display: none;
  }

  [data-theme="dark"] & {
    color: ${dark.text_secondary};
  }
`;

const CrossLink = styled.div`
  font-size: 13px;
  color: #374151;

  a {
    color: ${brand_orange_deep};
    font-weight: 700;
    text-decoration: none;
    margin-left: 6px;
  }

  a:hover, a:focus-visible {
    text-decoration: underline;
  }

  a:focus-visible {
    outline: 2px solid ${brand_orange_deep};
    outline-offset: 2px;
    border-radius: 2px;
  }

  [data-theme="dark"] & {
    color: ${dark.text_secondary};
  }

  @media ${narrowScreenMediaQuery} {
    font-size: 12px;
  }
`;

// `crossLink` may be `{ prompt, label, href }` — when omitted, no cross-link
// is rendered (used by CheckInbox / ConfirmEmail where the CTA lives in the
// body rather than the header).
export default function AuthHeader({ crossLink }) {
  return (
    <Bar>
      <Inner>
        <LogoLink href="/" aria-label="Kembali ke beranda Taxsam">
          <LogoImg
            src={unmodule(require("../images/taxsam-logo.png"))}
            alt="Taxsam Learning Center"
          />
        </LogoLink>
        <Tagline>Pusat Pelatihan Sertifikasi Pajak</Tagline>
        {crossLink ? (
          <CrossLink>
            {crossLink.prompt}
            <Link href={crossLink.href}>{crossLink.label}</Link>
          </CrossLink>
        ) : (
          <span aria-hidden="true" style={{ width: "1px" }} />
        )}
      </Inner>
    </Bar>
  );
}
